// Moving all possible steps into an object to avoid typos and not have to edit each file independently
export const audienceSortStepNames = {
	notSelecting: "display-not-selecting",
	initialStep: "display-initial-step",
	countrySelection: "display-country-selection",
	audienceTypeSelection: "display-audience-type-screen",
	financialProfessionalAffirmation: "display-affirmation-screen"
};
